import React from 'react';
import PropTypes from 'prop-types';

export default function NegativeIcon(props) {
  const { width, height } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 18 18'>
      <g id='Grupo_151742' data-name='Grupo 151742' transform='translate(-3639 20872)'>
        <path
          id='Caminho_21954'
          data-name='Caminho 21954'
          d='M8.564,1.289.2,16.256A.5.5,0,0,0,.636,17H17.364a.5.5,0,0,0,.436-.744L9.436,1.289a.5.5,0,0,0-.873,0ZM10,14.75a.25.25,0,0,1-.25.25H8.25A.25.25,0,0,1,8,14.75v-1.5A.25.25,0,0,1,8.25,13h1.5a.25.25,0,0,1,.25.25Zm0-3a.25.25,0,0,1-.25.25H8.25A.25.25,0,0,1,8,11.75v-6a.25.25,0,0,1,.25-.25h1.5a.25.25,0,0,1,.25.25Z'
          transform='translate(3638.864 -20872.033)'
          fill='#c9252d'
        />
        <g
          id='Placement_Area'
          data-name='Placement Area'
          transform='translate(3639 -20872)'
          fill='red'
          stroke='rgba(0,0,0,0)'
          strokeWidth='1'
          opacity='0'
        >
          <rect width={width} height={height} stroke='none' />
          <rect x='0.5' y='0.5' width='17' height='17' fill='none' />
        </g>
      </g>
    </svg>
  );
}

NegativeIcon.defaultProps = {
  fill: '#fff',
  width: 12.001,
  height: 10.662
};

NegativeIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
